module.exports = __webpack_public_path__ + "static/media/NoVideo.594c1aea.png";